var _path, _path2, _g, _path3, _path4, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPnlLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11903_21257)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4383 14.6761C24.4383 14.4391 24.4443 14.2821 24.4373 14.1261C24.4133 13.5821 23.9893 13.1611 23.4833 13.1731C22.9823 13.1851 22.5813 13.5971 22.5633 14.1291C22.5543 14.4091 22.5503 14.6911 22.5653 14.9711C22.5753 15.1541 22.5093 15.2331 22.3393 15.3081C21.2173 15.8031 20.5293 17.0401 20.7193 18.1941C20.9593 19.6701 21.9903 20.5741 23.5253 20.6581C23.9283 20.6801 24.2153 20.8751 24.3683 21.2451C24.5163 21.6051 24.4483 21.9431 24.1883 22.2281C23.9243 22.5151 23.5903 22.5901 23.2183 22.4881C22.8183 22.3801 22.5393 22.1021 22.2643 21.8141C21.8893 21.4231 21.3243 21.3921 20.9483 21.7301C20.5523 22.0841 20.5283 22.6401 20.8943 23.0681C21.1431 23.3482 21.4233 23.5988 21.7293 23.8151C21.9913 24.0081 22.4223 24.0231 22.5353 24.3211C22.6453 24.6121 22.5543 24.9781 22.5643 25.3101C22.5803 25.8531 23.0043 26.2781 23.5103 26.2701C24.0093 26.2631 24.4143 25.8521 24.4363 25.3201C24.4463 25.0821 24.4583 24.8401 24.4333 24.6041C24.4073 24.3421 24.4933 24.2101 24.7413 24.0921C25.8233 23.5751 26.4613 22.3671 26.2803 21.2481C26.0403 19.7751 25.0123 18.8721 23.4733 18.7851C23.0703 18.7621 22.7833 18.5671 22.6313 18.1961C22.5598 18.0382 22.5368 17.8627 22.5653 17.6917C22.5938 17.5208 22.6725 17.3622 22.7913 17.2361C23.0553 16.9341 23.3973 16.8511 23.7833 16.9541C24.0833 17.0341 24.3133 17.2261 24.5463 17.4211C24.9623 17.7711 25.5193 17.7311 25.8623 17.3451C26.1873 16.9781 26.1623 16.4151 25.7973 16.0501C25.5523 15.8061 25.2833 15.5731 24.9593 15.4651C24.5083 15.3151 24.3123 15.0641 24.4383 14.6761ZM32.0003 20.5331C31.8703 21.0001 31.8313 21.4851 31.6983 21.9541C31.2361 23.5788 30.3012 25.0294 29.0123 26.1214C27.7234 27.2133 26.1389 27.8972 24.4603 28.0861C20.0063 28.5921 15.9153 25.5311 15.1843 21.1461C14.4023 16.4541 17.5943 12.0631 22.2823 11.3781C26.8193 10.7141 31.0793 13.8051 31.8883 18.3381C31.9223 18.5281 31.8853 18.7361 32.0003 18.9111V20.5331Z",
    fill: "#F2AE00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11903_21257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 16,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55859 0H22.5666V31.948H7.55859V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11903_21257)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3147 31.948C11.3147 23.901 11.3147 15.855 11.3217 7.808C11.3217 7.543 11.2487 7.483 10.9937 7.488C10.1817 7.505 9.36874 7.496 8.55574 7.494C8.08674 7.492 7.76274 7.273 7.61674 6.866C7.47874 6.482 7.58674 6.106 7.93674 5.806C10.0857 3.966 12.2367 2.126 14.3887 0.287002C14.8357 -0.093998 15.2917 -0.096998 15.7397 0.286002C17.3467 1.656 18.9497 3.031 20.5557 4.404C21.1087 4.877 21.6707 5.341 22.2147 5.826C22.7967 6.345 22.6287 7.213 21.9147 7.454C21.7907 7.496 21.6687 7.494 21.5447 7.494C20.7417 7.494 19.9397 7.504 19.1377 7.488C18.8857 7.483 18.8007 7.538 18.8067 7.806C18.8257 8.638 18.8067 9.47 18.8187 10.301C18.8217 10.506 18.7537 10.603 18.5747 10.706C15.5207 12.453 13.7017 15.061 13.2667 18.552C12.7497 22.691 14.8707 26.708 18.5667 28.733C18.7627 28.84 18.8237 28.955 18.8177 29.166C18.8047 29.685 18.7887 30.206 18.8197 30.724C18.8547 31.297 18.6657 31.714 18.1267 31.948H11.3147Z",
    fill: "#02B27F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6875 31.948V14.297C5.6875 13.514 6.0255 13.173 6.8005 13.173C7.5605 13.173 8.3215 13.185 9.0805 13.167C9.3575 13.16 9.4435 13.223 9.4435 13.517C9.4335 19.494 9.4355 25.472 9.4355 31.449L9.4375 31.948H5.6875Z",
    fill: "#02B27F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11903_21257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 4,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.649H3.758V31.948H0V20.649Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11903_21257)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.3441C0.231 20.8271 0.626 20.6261 1.193 20.6511C1.909 20.6831 2.628 20.6741 3.345 20.6511C3.657 20.6411 3.759 20.7081 3.758 21.0471C3.744 24.6801 3.75 28.3141 3.75 31.9481H0.687C0.38019 31.8135 0.135037 31.5687 0 31.2621L0 21.3441Z",
    fill: "#02B27F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11903_21257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPnlLight);
export default __webpack_public_path__ + "static/media/ic-pnl-light.e462ae8e72632ff75bedf37dc2f36b91.svg";
export { ForwardRef as ReactComponent };